<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-hover v-slot="{ hover }">

          <v-card :style="{border: 'white'}"
                  :class="hover?'elevation-1 rounded-lg pa-5 glass-effect-hover':'elevation-1 rounded-lg pa-5 glass-effect'">
            <v-row>
              <v-card-title>
                <span class="white--text ml-2">{{ title }} </span>
                <supplier-select class="float-left" v-model="supplier"></supplier-select>
              </v-card-title>
              <v-card-text>
                <v-simple-table>
                  <thead>
                  <tr class="secondary">
                    <th class="text-center white--text" style="font-size: x-small">
                      کد محصول
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      نام محصول
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      تعداد کارتون
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      تعداد محصول در هر کارتون
                    </th>
                    <th class="text-center white--text" style="font-size: x-small">
                      تعداد محصول باقی مانده
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in packages">
                    <td class="text-center" style="font-size: x-small">
                      {{item.product_code}}
                    </td>
                    <td class="text-center" style="font-size: x-small">
                      {{item.default_name}}
                    </td>
                    <td class="text-center" style="font-size: x-small">
                      {{item.number_of_box}}
                    </td>
                    <td class="text-center" style="font-size: x-small">
                      {{item.number_of_products_per_box}}
                    </td>
                    <td class="text-center" style="font-size: x-small">
                      {{item.number_of_products}}
                    </td>
                  </tr>
                  </tbody>
                </v-simple-table>

              </v-card-text>

            </v-row>
          </v-card>
        </v-hover>
      </v-col>


      <v-col cols="12" md="6">
        <m-datatable :show-filter-row="false" :headers="headers" :apiUrl="url" :filters.sync="filters"
                     ref="datatable" :show-select="false"
                     @dblclick:row="(e, row) => $router.push(to(row.item))"
        >
        </m-datatable>


      </v-col>
    </v-row>

  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import Time from "@/components/mcomponents/cleave/Time";
import StoreSelect from "@/components/selects/StoreSelect";
import CurrencySelect from "@/components/selects/CurrencySelect";
import SupplierSelect from "@/components/selects/SupplierSelect";


export default {
  name: "SupplierEntrancePackageRemain",
  components: {SupplierSelect, CurrencySelect, StoreSelect, Time},
  mixins: [MFormMixin, formsMixin, FormsMixin],
  props: {
    id: {},
  },
  data() {
    return {
      url: "main/supplier/all",
      filters: {},
      packages: [],
      supplier: null,
    };
  },
  computed: {
    title() {
      return 'محصولات در انتظار تحویل'
    },
    headers() {
      return [
        {
          text: "نام تامین کننده",
          value: "name",
        },
        {
          text: "ادمین",
          value: "admin_name",
        },

      ];
    },
  },
  updated() {
  },
  mounted() {
    if (this.id) {
      this.getPackages()
      this.supplier = this.id
    }
  },
  watch: {
    id() {
      if (this.id) {
        this.packages = []
        this.supplier = this.id
        this.getPackages()
      }
    },
    supplier() {
      this.id = this.supplier
    }
  },
  methods: {
    to(item) {
      return {
        name: "SupplierEntrancePackageRemain",
        params: {
          id: item.id,
        },
      };
    },
    getPackages() {
      this.request({
        url: this.endpoint(`entrance/supplierPackageRemain/${this.id}`),
        method: "get",
        success: data => {
          this.packages = data
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.glass-effect {
  transition: backdrop-filter 0.5s ease;
  background-color: rgba(230, 230, 230, 0.2);
  backdrop-filter: blur(
          5px
  );
}

.glass-effect-hover {
  transition: backdrop-filter 0.5s ease;
  background-color: rgba(230, 230, 230, 0.2);
  backdrop-filter: blur(20px);
}
.cursor-pointer {
  cursor: pointer !important;
}

</style>

